module.exports = __webpack_public_path__ + "static/media/projects-hero.04f12d02.png";